// @ts-expect-error - date-chinese doesn't have TypeScript declarations
import { CalendarChinese } from 'date-chinese'

import { createDateWithOffset, isDateInDynamicWindow } from './helpers'
import { padDigits } from '../datetimeFormatUtils'

/**
 * Calculates Gregorian date for Chinese New Year of a specific year.
 */
export function getChineseNewYearDate(year: number): Date {
  const cal = new CalendarChinese()
  const cnyJDE = cal.newYear(year)
  cal.fromJDE(cnyJDE)
  const cnyDate = cal.toGregorian()
  // Note: CalendarChinese returns 1-based months and dates in Beijing Time (UTC+8)
  // Create Date with the user system offset
  return createDateWithOffset(
    `${cnyDate.year}-${padDigits(cnyDate.month)}-${padDigits(cnyDate.day)}`,
  )
}

/**
 * Logic to check if we are within the CNY window.
 * Refactored to use isDateInDynamicWindow.
 */
export function isChineseNewYearActive(today: Date): boolean {
  const currentYear = today.getUTCFullYear()
  const currentMonth = today.getUTCMonth()

  // Optimization: CNY usually falls in Jan (0) or Feb (1).
  // This confirmed as I check back until 1930. Only Jan and Feb need to be checked.
  if (currentMonth > 2 && currentMonth < 11) return false

  // Determine which year's CNY to check.
  const targetYear = currentMonth === 11 ? currentYear + 1 : currentYear
  const cnyDate = getChineseNewYearDate(targetYear)

  // Use the split function: 7 days before, 1 day after
  return isDateInDynamicWindow(today, cnyDate, 7, 1)
}
